import { ValidationErrors } from "@angular/forms";

export class AutoSaveContext {
  saving: boolean;
  saved: boolean;
  hasSavedValidValue: boolean;
  removing: boolean;
  serverErrors: string[] = [];
  valid: boolean;
  errors: ValidationErrors;
}


// WEBPACK FOOTER //
// ./src/app/pillar/workspace/AutoSaveContext.ts